const styles = theme => ({
  card: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: "19%",
    height: 350,
    display: "flex",
    flexDirection: "column",
    opacity: 1,
    transform: "scale(1)",
    transition: theme.transitions.create(["opacity", "transform"], {
      easing: theme.transitions.easing.sharp,
      duration: ".3s"
    })
  },
  cardHidden: {
    flexGrow: 1,
    opacity: 0,
    transform: "scale(0)"
  },
  media: {
    position: "relative",
    paddingTop: "40.09%",
    overflow: "hidden"
  },
  chip: {
    position: "absolute",
    top: theme.spacing.unit * 1.5,
    left: theme.spacing.unit * 1.5,
    border: `2px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "0.8rem"
  },
  auctionChip: {
    backgroundColor: "#0fe2d5"
  },
  raffleChip: {
    backgroundColor: "#cd46eb"
  },
  fixedChip: {
    backgroundColor: "#1ab394"
  },
  liveChip: {
    backgroundColor: "#e6c40a"
  },
  cardRoot: {
    padding: "12px 16px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "&:last-child": {
      paddingBottom: 12
    }
  },
  cardTitle: {
    textAlign: "left",
    fontSize: "1.25rem",
    lineHeight: "1",
    fontWeight: 400
  },
  donor: {
    fontStyle: "italic",
    fontSize: "0.8rem",
    color: theme.palette.grey[400],
    textAlign: "left",
    whiteSpace: "pre-line"
  },
  donorName: {
    display: "inline",
    fontSize: "inherit",
    fontStyle: "normal",
    color: theme.palette.grey[500],
    fontWeight: 500
  },
  cardBottom: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between"
  },
  itemCode: {
    fontFamily: "Oswald",
    fontWeight: 300,
    display: "inline",
    lineHeight: 0.87,
    fontSize: "1.25rem"
  },
  numbersArea: {
    textAlign: "right"
  },
  numbersAreaTitle: {
    textTransform: "uppercase",
    fontSize: "1.25rem",
    lineHeight: "1",
    fontWeight: 600
  },
  numbersAreaNumber: {
    fontFamily: "Oswald",
    fontSize: "1.4rem",
    fontWeight: 400,
    lineHeight: "1"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Item/styles.js